import styled from 'styled-components';

export const ParcelSliderContainer = styled.div`
  & .FormLabel {
    font-size: 14px;
    padding: 0;
    line-height: 18px;
    color: #606266;
  }
`;
